import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ReconciliationProvider } from './context/ReconciliationContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ReconciliationProvider>
          <App />
        </ReconciliationProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
